import { render, staticRenderFns } from "./mainBottom.vue?vue&type=template&id=4d75924b"
import script from "./mainBottom.vue?vue&type=script&lang=js"
export * from "./mainBottom.vue?vue&type=script&lang=js"
import style0 from "./mainBottom.vue?vue&type=style&index=0&id=4d75924b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports